import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_8 = { style: {"margin":"0 10px"} }

import { ref, onMounted, h } from "vue";
import { getCallable } from "@/config/env";
import {
  NDataTable,
  NSpace,
  NCheckbox,
  NCard,
  NSelect,
  NButton,
  NIcon,
  NModal,
  NRadio,
  NRadioGroup,
  NInput,
  FormInst,
  FormRules,
  useMessage,
  useNotification,
  useDialog,
  NInputGroup,
  NFormItem,
  NDatePicker,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import * as common from "@/assets/common/common";
import { Myreg } from "@/model/myreg";
import { QueryInfo } from "@/model/common";
import { usePagination } from "@/composables/usePagination";
import { useAuth } from "@/composables/useAuth";
import { useDownload } from "@/composables/useDownload";

export default /*@__PURE__*/_defineComponent({
  __name: 'Myreg',
  setup(__props) {

const { loading, isLoggedIn } = useAuth();
const { downloadNormalFile } = useDownload();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const getMyregsCallable = getCallable("getMyregs");
const componentKey = ref(0);
const deleteConfirmMessage = ref<string | null>(null);
const contentMessage = ref<string | null>(null);
const alertMessage = ref<string | null>(null);
const alertType = ref<string | null>(null);
const isDeleteConfirm = ref<boolean>(false);
const deleteConfirmType = ref<string | null>(null);
const isShowContent = ref<boolean>(false);
const isAlert = ref<boolean>(false);

const dateRange = ref<[number, number] | null>(null);

const searchValue = ref<string | null>(null);
const searchType = ref("name");
const searchOptions = [
  { label: "이름", value: "name" },
  { label: "연락처", value: "phoneNumber" },
  { label: "이메일", value: "email" },
];

const {
  paginatedItems: myregList,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshMyregs,
} = usePagination<OrgMyreg, { startDate?: string; endDate?: string }>(
  async (params) => getMyregs(params),
  25 // 페이지 크기
);

const getMyregs = async (params: any) => {
  if (searchValue.value && searchValue.value.trim() !== "") {
    params.searchKey = searchType.value;
    params.searchValue = searchValue.value.trim();
  }
  return await getMyregsCallable(params);
};

async function wrappedRefreshMyregs() {
  loading.value = true; // 전역 로딩 시작

  if (!dateRange.value) {
    message.error("기간을 선택해주세요.");
    return;
  }
  const [startTimestamp, endTimestamp] = dateRange.value;
  const startDate = startTimestamp.toString();
  const endDate = common.addDaysToTimestamp(endTimestamp, 1).toString();

  await composableRefreshMyregs({ startDate, endDate });
  loading.value = false; // 전역 로딩 종료
}

const columns = [
  {
    title: "순번",
    key: "index",
    render(_row: Myreg, rowIndex: number) {
      return rowIndex + 1;
    },
  },
  {
    title: "이름",
    key: "name",
    resizable: true,
  },
  {
    title: "연락처",
    key: "phoneNumber",
    resizable: true,
  },
  {
    title: "내용",
    sorter: "default",
    render(row: Myreg) {
      return h(
        NButton,
        {
          size: "small",
          onClick: () => {
            onShowContent(row);
          },
        },
        { default: () => common.parseContent(row.content) }
      );
    },
  },
  {
    title: "첨부파일",
    key: "attached_file_drive_id",
    render(row: Board) {
      return h(
        NButton,
        {
          size: "small",
          onClick: () => {
            onFileDonwload(row);
          },
          bordered: true,
        },
        { default: () => "다운로드" }
      );
    },
  },
  {
    title: "이메일",
    key: "email",
    resizable: true,
  },
  {
    title: "등록일",
    key: "createdDate",
    render(row: Myreg) {
      return common.getDate(row.createdDate);
    },
  },
];
async function onFileDonwload(row: Board) {
  loading.value = true;
  await downloadNormalFile(row.attached_file_drive_id, row.attached_file_name);
  loading.value = false;
}
function onShowContent(row: Myreg) {
  isShowContent.value = true;
  contentMessage.value = row.content;
}
function onPositiveClick() {
  isAlert.value = false;
}

async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}

onMounted(() => {
  // wrappedRefreshMyregs();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "개인 문의 관리", -1)
                ])),
                _: 1
              }),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _createVNode(_unref(NSpace), {
                vertical: "",
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    align: "center",
                    "item-style": "display: flex;"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NFormItem), {
                        label: "검색",
                        style: {"min-width":"350px"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInputGroup), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSelect), {
                                value: searchType.value,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event)),
                                options: searchOptions,
                                style: {"width":"120px"}
                              }, null, 8, ["value"]),
                              _createVNode(_unref(NInput), {
                                value: searchValue.value,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                                placeholder: "검색어를 입력하세요",
                                clearable: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), {
                        label: "등록일 선택",
                        style: {"min-width":"300px"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NDatePicker), {
                            value: dateRange.value,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dateRange).value = $event)),
                            type: "daterange",
                            clearable: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), {
                        style: {"margin-bottom":"0"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NButton), {
                            type: "primary",
                            onClick: wrappedRefreshMyregs,
                            disabled: !dateRange.value
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode(" 조회 ")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createElementVNode("div", null, [
                (_unref(listLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "개인 문의 목록을 불러오는 중..."))
                  : _createCommentVNode("", true),
                (_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                  : _createCommentVNode("", true),
                (!_unref(listLoading) && !_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_unref(myregList).length > 0)
                          ? (_openBlock(), _createBlock(_unref(NDataTable), {
                              key: 0,
                              columns: columns,
                              data: _unref(myregList),
                              pagination: false,
                              bordered: true
                            }, null, 8, ["data"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_6, "등록된 개인 문의가 없습니다."))
                      ]),
                      (_unref(myregList).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToPreviousPage,
                              disabled: _unref(currentPage) === 1,
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode(" 이전 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToNextPage,
                              disabled: !_unref(hasNextPage)
                            }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode(" 다음 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: isAlert.value,
            "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((isAlert).value = $event)),
            "mask-closable": false,
            content: alertMessage.value,
            type: alertType.value,
            preset: "dialog",
            title: "Dialog",
            "positive-text": "확인",
            onPositiveClick: onPositiveClick
          }, null, 8, ["show", "content", "type"]),
          _createVNode(_unref(NModal), {
            show: isShowContent.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((isShowContent).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NCard), {
                style: {"width":"600px"},
                title: "내용",
                bordered: false,
                size: "huge",
                role: "dialog",
                "aria-modal": "true"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(contentMessage.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: isDeleteConfirm.value,
            "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((isDeleteConfirm).value = $event)),
            "mask-closable": false,
            content: deleteConfirmMessage.value,
            type: deleteConfirmType.value,
            preset: "dialog",
            "negative-text": "취소",
            "positive-text": "확인",
            onPositiveClick: _ctx.onDeletePositiveClick,
            onNegativeClick: _ctx.onDeleteNegativeClick
          }, null, 8, ["show", "content", "type", "onPositiveClick", "onNegativeClick"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})